import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { PARTNER_CONTENT_STORY_TEMPLATE } from "../../../constants";
import { DfpComponent } from "../../ads/dfp-component";
import { StoryCard } from "./StoryCard";

import "./three-col-nine-var-three.m.css";

const getStories = ({ stories, showTimeStamp, showReadTime, showStorySeparator, sectionSlug }) => {
  return stories?.map((story, index) => {
    const sponsor = get(story, ["metadata", "sponsored-by"], null);
    const imageUrl =
      get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]) ||
      get(story, ["hero-image-s3-key"]);
    const showImageThumbnail = (story?.["story-template"] === PARTNER_CONTENT_STORY_TEMPLATE || sponsor) && imageUrl;
    return (
      <Fragment key={story?.id}>
        <StoryCard
          story={story}
          showTimeStamp={showTimeStamp}
          showReadTime={showReadTime}
          showImageThumbnail={showImageThumbnail}
          sectionSlug={sectionSlug}
        />
        {(index + 1) % stories?.length !== 0 && showStorySeparator && (index + 1) % 3 !== 0 && (
          <div styleName="divider"></div>
        )}
        {stories?.length > 3 && (index + 1) % 3 === 0 && showStorySeparator && <div styleName="row-divider"></div>}
      </Fragment>
    );
  });
};

const StoryList = ({
  showStorySeparator,
  stories,
  showTimeStamp,
  showReadTime,
  enableRowAd,
  rowAdDetails,
  rowAdConfig,
  pageType,
  collection,
  offset,
  sectionSlug,
}) => {
  const firstList = stories?.slice(0, 2);
  const rowAd = rowAdDetails?.split("/").slice(-1)[0];
  const rowAdDivId = useSelector((state) => get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAd], ""));
  let secondList = [];
  let storyList = [];
  if (offset < 9) {
    secondList = stories?.slice(2, 8);
    storyList = stories?.slice(0, 9);
  } else {
    const newList = [...stories?.slice(2, 8), ...stories?.slice(9)];
    secondList = newList;
    storyList = [...stories?.slice(0, 9), ...stories?.slice(9, stories.length)];
  }
  return enableRowAd && rowAdDetails ? (
    <>
      {getStories({ stories: firstList, showTimeStamp, showReadTime, showStorySeparator, sectionSlug })}
      {firstList.length === 2 && (
        <>
          {showStorySeparator && <div styleName="divider"></div>}
          <DfpComponent adStyleName="three-col-nine-row-ad-slot-size" id={rowAdDivId} isSponsored={true} />
        </>
      )}
      {showStorySeparator && <div styleName="row-divider"></div>}
      {getStories({ stories: secondList, showTimeStamp, showReadTime, showStorySeparator, sectionSlug })}
    </>
  ) : (
    getStories({ stories: storyList, showTimeStamp, showReadTime, showStorySeparator, sectionSlug })
  );
};

StoryList.propTypes = {
  collection: PropTypes.object,
  stories: PropTypes.array.isRequired,
  showStorySeparator: PropTypes.bool,
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  enableRowAd: PropTypes.bool,
  rowAdDetails: PropTypes.string,
  rowAdConfig: PropTypes.object,
  pageType: PropTypes.string,
  onLoad: PropTypes.bool,
  sectionSlug: PropTypes.string,
};

export default StoryList;
